import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { IROH_SERVICES_API_PREFIX } from "@/api/domain"

// Minimal public project information
type PublicProjectInfo = {
  id: string
  name: string
  description?: string
}

// Minimal public repo information
type PublicRepoInfo = {
  clone_url: string
  default_branch: string
}

// Define a service for public endpoints that don't require authentication
export const publicApi = createApi({
  reducerPath: "publicApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${IROH_SERVICES_API_PREFIX}projects/public`,
    mode: "cors",
    // No credentials for public endpoints
  }),
  endpoints: (build) => ({
    publicProjectsGetByName: build.query<
      PublicProjectInfo,
      { username: string; project_name: string }
    >({
      query: ({ username, project_name }) => ({
        url: `${username}/${project_name}`,
      }),
    }),
    publicProjectsGetReadme: build.query<
      string,
      { username: string; project_name: string }
    >({
      query: ({ username, project_name }) => ({
        url: `${username}/${project_name}/readme`,
        responseHandler: "text",
      }),
    }),
    publicProjectsGetRepo: build.query<
      PublicRepoInfo,
      { username: string; project_name: string }
    >({
      query: ({ username, project_name }) => ({
        url: `${username}/${project_name}/repo`,
      }),
    }),
  }),
})

export const {
  usePublicProjectsGetByNameQuery,
  usePublicProjectsGetReadmeQuery,
  usePublicProjectsGetRepoQuery,
} = publicApi
